<template>
    <v-flex v-if="selectedAd">
        <v-row class="center">
            <v-col cols="12" md="8">
                <v-row>
                    <v-col style="margin-left: auto;" class="my-2" lg="6" md="8" cols="10">
                        <v-card class="pa-1">
                            <v-row class="center my-2">
                                <v-col>
                                    <v-row class="center">
                                        <h3>Ad Type</h3>
                                    </v-row>
                                    <v-row class="my-2" style="justify-content: space-evenly;">
                                        <v-card :ripple="{ class: 'secondary-icon' }" @click="selectedAd.type = advertisementTypes.SLIDER" class="ad-type-card" :color="selectedAd.type === advertisementTypes.SLIDER ? 'secondary-ripple' : ''">
                                            <span>Slider</span>
                                        </v-card>
                                        <v-card :ripple="{ class: 'secondary-icon' }" @click="selectedAd.type = advertisementTypes.CARD" class="ad-type-card" :color="selectedAd.type === advertisementTypes.CARD ? 'secondary-ripple' : ''">
                                            <span>Card</span>
                                        </v-card>
                                    </v-row>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col>
                                    <v-row class="center">
                                        <h3>Activate Ad</h3>
                                    </v-row>
                                    <v-row class="center my-2" style="justify-content: space-evenly;">
                                        <v-card :ripple="{ class: 'primary-icon' }" @click="activateAd" id="active-ad-card" :color="selectedAd.isActive ? 'primary-ripple' : ''">
                                            <span>{{ selectedAd.isActive ? 'Active' : 'Inactive' }}</span>
                                        </v-card>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col style="display: flex; align-items: center; justify-content: center;" class="my-2" lg="3" md="4" cols="2">
                        <site-button
                            btnType="tile"
                            colorClasses="calendar-add-btn"
                            :colNum="8"
                            @click-event="saveChanges"
                            toolTip="Save Changes"
                            iconString="far fa-save"
                        ></site-button>
                    </v-col>
                </v-row>
                <v-card>
                    <v-container>
                        <v-row class="center">
                            <h2>Location Audience</h2>
                        </v-row>
                        <v-row>
                            <google-map ref="map" @click="mapClick" style="width: 100%; height: 400px" :center="center" :zoom="8">
                                <info-window
                                    :options="infoWindowOptions.infoOptions"
                                    :position="infoWindowOptions.infoWindowPos"
                                    :opened="infoWindowOptions.infoWinOpen"
                                    @closeclick="infoWindowOptions.infoWinOpen = false"
                                >
                                    <site-button
                                        colorClasses="secondary-icon"
                                        @click-event="confirmCircle(selectedCircle)"
                                        :colNum="1"
                                        toolTip="Confirm Area"
                                        iconType="ICON"
                                        iconString="fas fa-check-circle"
                                    ></site-button>
                                    <site-button
                                        colorClasses="secondary-icon"
                                        @click-event="deleteCircle(selectedCircle)"
                                        :colNum="1"
                                        toolTip="Delete Advertisement"
                                        iconType="ICON"
                                        iconString="fas fa-trash"
                                    ></site-button>
                                </info-window>

                                <GmapCircle
                                    v-if="focusedCircle"
                                    @click="toggleInfoWindow($event, focusedCircle, focusedCircle.localId)"
                                    @drag="updateCoordinates($event, focusedCircle)"
                                    :title="focusedCircle.title"
                                    :center="focusedCircle.center"
                                    :radius="focusedCircle.radius"
                                    :visible="true"
                                    :draggable="true"
                                    :options="focusedCircle.options"
                                ></GmapCircle>
                                <GmapCircle
                                    v-for="(cir, i) in radiusCircles"
                                    @click="toggleInfoWindow($event, cir, cir.localId)"
                                    @drag="updateCoordinates($event, cir)"
                                    :key="i"
                                    :title="cir.title"
                                    :center="cir.center"
                                    :radius="cir.radius"
                                    :visible="true"
                                    :draggable="true"
                                    :options="cir.options"
                                ></GmapCircle>
                            </google-map>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <v-col cols="11" md="3">
                <v-card v-if="!isMobile" class="pa-6">
                    <v-row class="center mb-6">
                        <h2>Targeting Filters</h2>
                    </v-row>
                    <v-row class="center">
                        <h3>Age Range</h3>
                    </v-row>
                    <v-row>
                        <v-range-slider v-model="ageRange" :max="70" :min="21">
                            <template v-slot:prepend>
                                <span>{{ ageRange[0] }}</span>
                            </template>
                            <template v-slot:append>
                                <span>{{ ageRange[1] }}</span>
                            </template>
                        </v-range-slider>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="center">
                        <h2>Gender</h2>
                    </v-row>
                    <v-row class="my-6" style="justify-content: space-evenly;">
                        <v-card @click="gender = 'Male'" class="gender-card" :color="gender === 'Male' ? 'primary' : ''">
                            <span>Male</span>
                        </v-card>
                        <v-card @click="gender = 'Female'" class="gender-card" :color="gender === 'Female' ? 'primary' : ''">
                            <span>Female</span>
                        </v-card>
                        <v-card @click="gender = 'All'" class="gender-card" :color="gender === 'All' ? 'primary' : ''">
                            <span>All</span>
                        </v-card>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="center">
                        <h2>Popular Keywords</h2>
                    </v-row>
                    <v-row>
                        <v-chip-group class="center" v-model="selectedKeywords" multiple column active-class="primary--text">
                            <v-chip v-for="tag in popularKeywords" :key="tag" :value="tag">
                                {{ tag }}
                            </v-chip>
                        </v-chip-group>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="center">
                        <h3>Custom Keywords</h3>
                    </v-row>
                    <v-row class="center">
                        <v-col style="display: flex; space-between;">
                            <v-text-field
                                color="#00006d"
                                label="Keyword"
                                class="col-8"
                                v-model="keywordField"
                            ></v-text-field>
                            <v-btn text color="green accent-3" style="min-height: 50px;"
                                class="col-4" @click.stop="addCustomKeyword">
                                <v-icon>fas fa-plus-circle</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-container>
                        <v-row>
                            <v-col>
                                <span v-if="customKeywordLength > 0">(Click chip to delete term)</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-chip @click="deleteKeyword(index)" :ripple="false"
                                    class="center mx-3 my-3" v-for="(tag, index) in customKeywords" :key="index">
                                        <v-icon style="margin: 5px;">fas fa-search-location</v-icon>
                                        <span style="margin: 5px;">{{ tag }}</span>
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <v-card v-else class="pa-6">
                    <v-row class="center">
                        <h2>Targeting Filters</h2>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <h3 class="mobile-header">Age Range</h3>
                            <v-range-slider vertical v-model="ageRange" :max="70" :min="21">
                                <template v-slot:prepend>
                                    <span>{{ ageRange[0] }}</span>
                                </template>
                                <template v-slot:append>
                                    <span>{{ ageRange[1] }}</span>
                                </template>
                            </v-range-slider>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="6">
                            <h3 class="mobile-header">Popular Keywords</h3>
                            <v-chip-group class="center" v-model="selectedKeywords" multiple column active-class="primary--text">
                                <v-chip v-for="tag in popularKeywords" :key="tag" :value="tag">
                                    {{ tag }}
                                </v-chip>
                            </v-chip-group>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="3" class="vertical-gender-list center">
                            <h3 class="mobile-header">Gender</h3>
                            <v-card
                                @click="gender = 'Male'"
                                class="gender-card"
                                :color="gender === 'Male' ? 'primary' : ''"
                            >
                                <span>Male</span>
                            </v-card>
                            <v-card
                                @click="gender = 'Female'"
                                class="gender-card"
                                :color="gender === 'Female' ? 'primary' : ''"
                            >
                                <span>Female</span>
                            </v-card>
                            <v-card
                                @click="gender = 'All'"
                                class="gender-card"
                                :color="gender === 'All' ? 'primary' : ''"
                            >
                                <span>All</span>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="center">
                        <h3>Custom Keywords</h3>
                    </v-row>
                    <v-row class="center">
                        <v-col style="display: flex; space-between;" cols="7">
                            <v-text-field
                                color="#00006d"
                                label="Keyword"
                                class="col-8"
                                v-model="keywordField"
                            ></v-text-field>
                            <v-btn text color="green accent-3" style="min-height: 50px;"
                                class="col-4" @click.stop="addCustomKeyword">
                                <v-icon>fas fa-plus-circle</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-container>
                        <v-row>
                            <v-col>
                                <span v-if="customKeywordLength > 0">(Click chip to delete term)</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-chip @click="deleteKeyword(index)" :ripple="false"
                                    class="center mx-3 my-3" v-for="(tag, index) in customKeywords" :key="index">
                                        <v-icon style="margin: 5px;">fas fa-search-location</v-icon>
                                        <span style="margin: 5px;">{{ tag }}</span>
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-flex>
</template>

<style lang="scss" scoped>
.mobile-header {
    margin: 1em 0px;
}

::v-deep .v-slide-group__content {
    display: flex;
    justify-content: center;
}

.ad-type-card{
    width: 75px;
    height: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: .5em;
}

.gender-card {
    padding: 1em 0.5em;
    min-width: 70px;
    margin: 5px;
}

.vertical-gender-list {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}
</style>

<script>
import Gmap from 'vue2-google-maps/src/components/map'
import InfoWindow from 'vue2-google-maps/src/components/infoWindow'
import SiteButton from '../../../components/common/SiteButton';
import AdvertisementType from '../../../assets/Enums/AdvertisementType';
import GeoHash from 'ngeohash';
import Conversion from '../../../assets/Enums/ConversionEnums'
import GeoPrecision from '../../../assets/Enums/GeoHashEnums';
import { nanoid } from 'nanoid';
import _ from 'lodash';

export default {
    name: 'targeted-marketing',
    components: {
        'google-map': Gmap,
        'site-button': SiteButton,
        'info-window': InfoWindow,
    },
    props: {
        adIndex: {
            type: [Number, String],
            default: -1
        }
    },
    data: () => ({
        center: {
            lat: 42.584534,
            lng: -82.831139,
        },
        isNewAd: false,
        radiusCircles: [],
        selectedCircle: null,
        focusedCircle: null,
        popularKeywords: ["Test","Testing", "Jest", "Best","Fest", "Less"],
        infoWindowOptions: {
            infoWindowPos: null,
            infoWinOpen: false,
            currentMidx: null,
            bottomLeftLat: null,
            bottomLeftLng: null,
            topRightLat: null,
            topRightLng: null,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35,
                },
            },
        },
        selectedAd: null,
        ageRange: [21, 70],
        customKeywords: [],
        selectedKeywords: [],
        keywordField: '',
        gender: null
    }),
    created(){
        const geoHash = GeoHash.decode(this.$store.getters.geoHashGroup);

        this.center = { lat: geoHash.latitude, lng: geoHash.longitude };
    },
    mounted(){
        const index = parseInt(this.adIndex);
        console.log('IND: ' + index);
        this.selectedAd = index >= 0 ? JSON.parse(JSON.stringify(this.availableAdvertisements[index])) : null;
        if(this.selectedAd){
            this.ageRange = [this.selectedAd.targetMarket.ageStart, this.selectedAd.targetMarket.ageEnd];
            this.gender = _.isEqual(this.selectedAd.targetMarket.genders,['Male', 'Female']) ? 'All' : 
                this.selectedAd.targetMarket.genders.findIndex(s => s === 'Male') > -1 ? 'Male' : 'Female';
            this.customKeywords = this.selectedAd.targetMarket.keyWords;
        }
    },
    methods: {
        editAd(index){
            this.selectedAd = this.availableAdvertisements[index];
        },
        deleteAd(){
            
        },
        saveChanges(){
            if(this.geoHashAudience.length === 0){
                this.$store.dispatch('SHOW_SNACKBAR', 'Click the map to pick advertisement locations');
                return;
            }

            this.selectedAd.targetMarket.activeAreas = this.geoHashAudience;
            this.selectedAd.targetMarket.keyWords = [...new Set([...this.selectedKeywords, ...this.customKeywords])];
            this.selectedAd.targetMarket.genders = this.gender === 'All' ? ['Male', 'Female'] : 
                this.gender === 'Male' ? ['Male'] : ['Female'];
            this.selectedAd.targetMarket.ageStart = this.ageRange[0];
            this.selectedAd.targetMarket.ageEnd = this.ageRange[1];
            console.log(this.selectedAd);
            this.$store.dispatch('SUBMIT_AD_DESIGN', { ad: this.selectedAd, index: this.adIndex }).then(() => {
                this.$store.dispatch('SHOW_SNACKBAR','Design Submitted!');
            });
        },
        deleteCircle(cir){
            const circleIndex = this.radiusCircles.findIndex(s => s && s.localId === cir.localId);
            console.log('index: ' + this.deleteCircleId);
            if(this.focusedCircle && this.focusedCircle.localId == cir.localId){
                this.focusedCircle = null;
            } 

            if(circleIndex > -1){
                this.radiusCircles.splice(circleIndex, 1);
            }

            this.selectedCircle = null;
            this.infoWindowOptions.infoWinOpen = false;
        },
        confirmCircle(cir){
            console.log(cir);
            const circle = cir;

            circle.isActive = true;
            circle.options.fillColor = '#00006d';
            circle.options.fillOpacity = .5;
            
            if(!circle.geoHashes.every(s => this.geoHashAudience.includes(s))){
                this.radiusCircles.push(circle);
            } else {
                console.log('already advertising');
            }

            this.selectedCircle = null;
            this.infoWindowOptions.infoWinOpen = false;
        },
        activateAd(){
            this.selectedAd.isActive = !this.selectedAd.isActive;
        },
        toggleInfoWindow($event, circle, idx) {
            $event.stop()
            this.infoWindowOptions.infoWindowPos = circle.center;

            if (this.infoWindowOptions.currentMidx == idx) {
                this.infoWindowOptions.infoWinOpen = !this.infoWinOpen;
            } else {
                this.infoWindowOptions.infoWinOpen = true;
                this.infoWindowOptions.currentMidx = idx;
            }
            this.selectedCircle = circle;
        },
        adTypeChange(){

        },
        updateCoordinates(event, circle){
            const newLoc = { lat: event.latLng.lat(), lng: event.latLng.lng() };
            const radius = circle.radius;
            circle.center = newLoc;
            circle.poles = {
                north: { 
                    lat: newLoc.lat, lng: newLoc.lng + (radius / Conversion.METERTONAUTDEGREE), 
                    geoHash: GeoHash.encode(newLoc.lat, newLoc.lng + (radius / Conversion.METERTONAUTDEGREE), GeoPrecision.MarketingPrecision)
                },
                south: { 
                    lat: newLoc.lat, lng: newLoc.lng - (radius / Conversion.METERTONAUTDEGREE ),
                    geoHash: GeoHash.encode(newLoc.lat, newLoc.lng - (radius / Conversion.METERTONAUTDEGREE), GeoPrecision.MarketingPrecision)
                },
                east: { 
                    lat: newLoc.lat + (radius / Conversion.METERTONAUTDEGREE ), lng: newLoc.lng,
                    geoHash: GeoHash.encode(newLoc.lat + (radius / Conversion.METERTONAUTDEGREE ), newLoc.lng, GeoPrecision.MarketingPrecision)
                },
                west: { 
                    lat: newLoc.lat - (radius / Conversion.METERTONAUTDEGREE ), lng: newLoc.lng,
                    geoHash: GeoHash.encode(newLoc.lat - (radius / Conversion.METERTONAUTDEGREE ), newLoc.lng, GeoPrecision.MarketingPrecision)
                }
            };
            console.log(Object.values(circle.poles).map(s => s.geoHash));
            circle.geoHashes = new Set(Object.values(circle.poles).map(s => s.geoHash));
        },
        mapClick(data){
            const loc = { lat: data.latLng.lat(), lng: data.latLng.lng() };
            const radius = 10000;
            this.$refs.map.panTo(loc);
            const focusedCircle = {
                localId: nanoid(6),
                isActive: false,
                center: loc,
                radius: radius,
                geoHashes: [],
                poles: {
                    north: { 
                        lat: loc.lat, lng: loc.lng + (radius / Conversion.METERTONAUTDEGREE), 
                        geoHash: GeoHash.encode(loc.lat, loc.lng + (radius / Conversion.METERTONAUTDEGREE), GeoPrecision.MarketingPrecision)
                    },
                    south: { 
                        lat: loc.lat, lng: loc.lng - (radius / Conversion.METERTONAUTDEGREE ),
                        geoHash: GeoHash.encode(loc.lat, loc.lng - (radius / Conversion.METERTONAUTDEGREE), GeoPrecision.MarketingPrecision)
                    },
                    east: { 
                        lat: loc.lat + (radius / Conversion.METERTONAUTDEGREE ), lng: loc.lng,
                        geoHash: GeoHash.encode(loc.lat + (radius / Conversion.METERTONAUTDEGREE ), loc.lng, GeoPrecision.MarketingPrecision)
                    },
                    west: { 
                        lat: loc.lat - (radius / Conversion.METERTONAUTDEGREE ), lng: loc.lng,
                        geoHash: GeoHash.encode(loc.lat - (radius / Conversion.METERTONAUTDEGREE ), loc.lng, GeoPrecision.MarketingPrecision)
                    }
                },
                options: {
                    fillColor: '#2525e8',
                    fillOpacity: .3
                }
            }
            focusedCircle.geoHashes = [...new Set(Object.values(focusedCircle.poles).map(s => s.geoHash))];
            this.focusedCircle = focusedCircle;
            this.deleteCircleId = focusedCircle.localId;
        },
        goToCardAd(){
            this.$router.push('business-branding');
        },
        goToSliderAd(){
            this.$router.push('slider-ads');
        },
        activateNewArea($event, cir){
            $event.stop();
            const circle = cir;

            circle.isActive = true;
            circle.options.fillColor = '#00006d';
            circle.options.fillOpacity = .5;
            
            if(!circle.geoHashes.every(s => this.geoHashAudience.includes(s)) || this.radiusCircles.length === 0){
                this.radiusCircles.push(circle);
            } else {
                console.log('already advertising');
            }

            this.focusedCircle = null;
        },
        editAdvertisement(){

        },
        addCustomKeyword(){
            console.log(this.keywordField);
            if(this.customKeywords.findIndex(s => s == this.keywordField) === -1){
                this.customKeywords.push(this.keywordField);
                this.keywordField = '';
            }
        },
        deleteKeyword(index) {
            console.log('delete at ' + index);
            this.customKeywords.splice(index, 1);
        },
    },
    computed: {
        cardHeight() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '450'
                default:
                    return '500'
            }
        },
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true;
                case 'sm':
                  return true;
                default:
                    return false;
            }
        },
        availableAdvertisements(){
            return this.$store.getters.allAds;
        },
        hasAds(){
            return this.$store.getters.allAds.length > 0;
        },
        geoHashAudience(){
            const geoHashes = [];

            this.radiusCircles.forEach(item => {
                geoHashes.push(...item.geoHashes);
            });

            return [...new Set(geoHashes)];
        },
        advertisementTypes(){
            return AdvertisementType;
        },
        customKeywordLength(){
            return this.customKeywords.length || 0;
        }
    },
}
</script>